<template>
  <div class="export-transferencias-datos">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Información del Export">
          <b-table 
              class="datos-objeto" 
              responsive="sm" 
              :items="exportTransferenciasDatos" 
              :fields="fields">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Transferencias">
          <b-form>
            <b-form-group
              label="Nombre:"
              label-for="nombreBusqueda"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombreBusqueda" 
                v-model="nombreBusqueda"
                class="text-upper" 
                type="text">
              </b-form-input>
            </b-form-group>
          </b-form>

          <b-table 
              class="registro transferencias"
              responsive="sm" 
              :items="exportTransferenciasRenglonesDatos" 
              :fields="renglonesFields"
              :filter="nombreBusqueda"
              :filter-function="filtroTransferencias"
              :current-page="paginaActual"
              :per-page="registrosPorPagina"
              @filtered="onFiltered">
            <template v-slot:cell(cbu-cvu-alias)="data">
              {{ (data.item.cbu + ' ' + data.item.cbuAlias).trim() }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
            <template v-slot:cell(detailShowing)="row">
              <b-btn class="detailShowing" 
                  size="sm" 
                  v-if="row.item.transferenciasParticipantes.length != 0" 
                  @click.stop="row.toggleDetails">
                {{ ( row.detailShowing) ? '-' : '+' }}
              </b-btn>            
            </template>

            <template slot="row-details" slot-scope="row">
              <b-table 
                  class="registro participantes" 
                  responsive="sm" 
                  :items="row.item.transferenciasParticipantes" 
                  :fields="participantesFields">
                <template v-slot:cell(importe)="data">
                  {{ data.item.importe | moneda }}
                </template>
              </b-table>
            </template>

          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goList">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'exportTransferencias/getField',
  mutationType: 'exportTransferencias/updateField',
});

export default {
  name: 'ExportTransferenciasData',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal 
  ],
  data: () => {
    return {
      exportTransferenciasId: 0,

      fields: [
        {key: 'campo'},
        {key: 'valor'},
      ],

      renglonesFields: [
        { 
          key: 'detailShowing',
          label: '',
          class: 'text-center' 
        },
        // {
        //   key: 'evento',
        // },
        // {
        //   key: 'participante',
        // },
        {
          key: 'banco',
        },
        {
          key: 'cbu-cvu-alias',
          label: 'CBU/CVU/Alias'
        },
        // {
        //   key: 'cbuAlias',
        //   label: 'CBU Alias'
        // },
        {
          key: 'titularCuenta',
          label: 'Titular'
        },
        {
          key: 'titularCuit',
          label: 'CUIT'
        },
        {
          key: 'importe',
          class: 'text-right' 
        },
        // {
        //   key: 'email',
        // },
      ],

      participantesFields: [
        { 
          key: 'participante' 
        },
        {
          key: 'importe',
          class: 'text-right' 
        },
      ],

      // filterFields: [ titularCuenta ],
      
      nombreBusqueda: '',
      labelCols: 1,
      paginaActual: 1,
      totalPaginas: 1,
      registrosPorPagina: 10,
      totalRegistros: 0,      
    }
  },
  computed: {
    ...mapFields([
      'exportTransferenciasDatos',
      'exportTransferenciasRenglonesDatos',
      // 'paginaActual',
      // 'registrosPorPagina',
      // 'totalRegistros',
      // 'totalPaginas',
    ]),
  },
  created() {
    if (this.$route.params){
      if (this.$route.params.id){
        this.exportTransferenciasId = this.$route.params.id;
      }
    }

    this.showSpinner();
    this.$store.dispatch('exportTransferencias/getDatos', this.exportTransferenciasId)
      .then(() => {
        this.totalRegistros = this.exportTransferenciasRenglonesDatos.length;
      })
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    filtroTransferencias(row, filter) {
      return row.titularCuenta.toUpperCase().trim().includes(filter.toUpperCase().trim()) 
        || row.cbu.toUpperCase().trim().includes(filter.toUpperCase().trim())
        || row.cbuAlias.toUpperCase().trim().includes(filter.toUpperCase().trim())
        || row.banco.toUpperCase().trim().includes(filter.toUpperCase().trim())
        || row.titularCuit.toUpperCase().trim().includes(filter.toUpperCase().trim())
        || row.importe.toString().toUpperCase().trim().includes(filter.toUpperCase().trim());
    },
    goList () {
      this.$router.push({ name: 'ExportTransferencias' });
    },
    onFiltered(filteredItems) {
      this.totalRegistros = filteredItems.length
      this.paginaActual = 1
    }    
  },
  watch: {
  }   
}
</script>

<style>
  .export-transferencias-datos .datos-objeto table td[aria-colindex="1"] {
    width: 20%;
  }
  .reporte-validaciones .datos-objeto table td[aria-colindex="2"] {
    width: 80%;
  }

  .export-transferencias-datos table th {
    border-top: none;
  }
  .export-transferencias-datos table td {
    padding-top: 10px;
    padding-bottom: 5px;
  }
  .export-transferencias-datos .registro.transferencias table td[aria-colindex="1"] {
    width: 30px;
  }
  .export-transferencias-datos .registro.transferencias table td[aria-colindex="2"] {
    width: 25%;
  }
  .export-transferencias-datos .registro.transferencias table td[aria-colindex="3"] {
    width: 15%;
  }
  .export-transferencias-datos .registro.transferencias table td[aria-colindex="4"] {
    width: calc(40% - 30px);
  }
  .export-transferencias-datos .registro.transferencias table td[aria-colindex="5"],
  .export-transferencias-datos .registro.transferencias table td[aria-colindex="6"] {
    width: 10%;
  }

  .export-transferencias-datos .registro.transferencias .b-table-details > td {
    padding-left: 50px;
    padding-right: 0;
    padding-top: 0;
  }

  .export-transferencias-datos .registro.participantes table td[aria-colindex="1"] {
    width: 80%;
  }
  .export-transferencias-datos .registro.participantes table td[aria-colindex="2"] {
    width: 20%;
  }
</style>